/**
 * 全局公共mutations
 */

import { lodashUtils } from '../utils';

function setDeepValue(state, keyString, value) {
    if (keyString.indexOf('.') > -1) {
        setDeepValue(state[keyString.split('.')[0]], keyString.split('.')[1], value);
    } else {
        state[keyString] = value;
    }
}

function setTargetValue(state, keyString, value) {
    if (keyString.indexOf('.') > -1) {
        // 匹配'a.b.c.d'模式进行递归
        setDeepValue(state, keyString, value);
    } else {
        state[keyString] = value;
    }
}

export default ({
    SET_STATE(state, payload) {
        if (lodashUtils.isObject(payload)) {
            for (const key in payload) {
                setTargetValue(state, key, payload[key]);
            }
        } else {
            throw new Error('payload must be Object');
        }
    },
});
